export { default } from './SearchSlider';
